import { Plus, X } from "lucide-react";
import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { FAQQuestion } from "@/types/faq";

interface FAQAccordionProps {
  questions: FAQQuestion[];
  onQuestionClick?: (questionId: string) => void;
}

export const FAQAccordion = ({
  questions,
  onQuestionClick,
}: FAQAccordionProps) => {
  const [openItem, setOpenItem] = useState<string>("");

  return (
    <Accordion
      type="single"
      collapsible
      value={openItem}
      onValueChange={setOpenItem}
      className="w-full space-y-3"
    >
      {questions.map((faq) => (
        <AccordionItem
          key={faq.id}
          value={faq.id}
          className="border border-border rounded-lg bg-card hover:shadow-md transition-all duration-300"
        >
          <AccordionTrigger className="px-8 py-6 hover:no-underline group">
            <div className="flex items-start gap-4 text-left flex-1">
              <span className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors leading-relaxed">
                {faq.question}
              </span>
            </div>
            <div className="ml-4">
              {openItem === faq.id ? (
                <X className="w-6 h-6 text-primary shrink-0" />
              ) : (
                <Plus className="w-6 h-6 text-muted-foreground group-hover:text-primary shrink-0 transition-colors" />
              )}
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-8 pb-6">
            <div className="prose prose-base max-w-none text-muted-foreground whitespace-pre-line leading-relaxed">
              {faq.answer.split("\n").slice(0, 3).join("\n")}...
            </div>
            {onQuestionClick && (
              <button
                type="button"
                onClick={() => onQuestionClick(faq.id)}
                className="mt-6 text-base font-semibold text-primary hover:underline inline-flex items-center gap-2"
              >
                Citește răspunsul complet →
              </button>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
